// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"463":"59ff8ca9","787":"50f95899","831":"4a67834b"}[chunkId] + ".chunk.js";
};